module.exports = __webpack_public_path__ + "static/stormking-zoom-50579e35378dd732cba72bbaac2880db.jpg";